export default {"src":"/_next/static/media/finance-trend.5db3be19.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};